const router = {
    custom : '/custom.html',
    userOpus : '/useropus.html',
    certIfication : '/certification.html',
    editUserInfo : '/edituserinfo.html',
    upLoadWorks : '/uploadworks.html',
    userDing : '/userding.html',
    opusDetail : '/opusdetail.html',
    // begindesign : '/begindesign.html',
    userOrder : '/userorder.html',
    userAdress : '/useradress.html',
    userIncome : '/userincome.html',
    userInfo : '/userinfo.html',
    orderDetail : '/orderdetail.html',
    myMessage : '/mymessage.html',
    car : '/car.html',
    login : '/login.html',
    register : '/register.html',
    binDing : '/binding.html',
    order : '/order.html',
    pay : '/pay.html',
    opus : '/opus.html',
    desginer : '/desginer.html',
    accountSelf : '/accountself.html',
    desginerInfo : '/desginerinfo.html',
    touchCustom : '/touchCustom.html',
    touchCar : '/touchCar.html',
    treaty : '/treaty.html',
}

export default router


// WEBPACK FOOTER //
// ./src/assets/js/router.js